import React from 'react'
import { observer } from 'mobx-react'
import isArray from 'lodash/isArray'
import sortBy from 'lodash/sortBy'
import RGL, { WidthProvider } from 'react-grid-layout'
import {
  IoIosEye as VisibilityOn,
  IoIosEyeOff as VisibilityOff,
} from 'react-icons/io'
import { AccordionBlock } from 'src/views/components'
import { isMerchPLP } from 'config/appConfig'
import { merchProductContainer } from 'src/models'

const ReactGridLayout = WidthProvider(RGL)

@observer
class AccordionDragAndDrop extends React.Component {
  componentDidMount() {
    if (isMerchPLP) {
      merchProductContainer.setFacetPositions(this.props.filterList)
    }
  }

  onLayoutChange = props => {
    if (isArray(props) && merchProductContainer.facetPositions.length > 0) {
      const { cols } = this.props
      const positionedArray = props.map(data => {
        const { i } = data
        const position = data.y * cols + data.x + 1
        return {
          ...merchProductContainer.facetPositions.find(
            value => value.facetId === i
          ),
          position,
        }
      })
      merchProductContainer.facetPositions = sortBy(positionedArray, [
        product => {
          return product.position
        },
      ])
    }
  }

  handleVisibilityToggle = params => {
    const { selectedFacet, type, isOpen } = params
    const { filterList } = this.props

    filterList.map((item, index) => {
      const name = item.name !== null ? item.name.toLowerCase() : item.name
      if (name === selectedFacet.toLowerCase()) {
        filterList[index].isVisible = isOpen
      }
    })

    const facetPositions = merchProductContainer.facetPositions
    const currentIndex = facetPositions.findIndex(
      facet => facet.facetId === type
    )
    const visible = facetPositions[currentIndex]?.visible
    merchProductContainer.facetPositions = facetPositions.map((data, index) => {
      if (index !== currentIndex) {
        return { ...data }
      } else {
        return {
          ...data,
          visible:
            visible === undefined || visible === '' || visible === true
              ? false
              : true,
        }
      }
    })
  }

  renderIcon = isOpen => {
    return isOpen ? <VisibilityOff /> : <VisibilityOn />
  }

  renderActiveFilter = item => {
    if (item && item.isVisible !== '' && item.isVisible !== undefined) {
      return item.isVisible
    } else {
      return isMerchPLP
    }
  }

  render() {
    if (!isMerchPLP) {
      const { wrapper, renderDesktopFilter, filterList } = this.props
      return wrapper(filterList.map(renderDesktopFilter))
    }

    return (
      <ReactGridLayout
        cols={this.props.cols}
        isResizable={false}
        rowHeight={200}
        isDraggable={true}
        autoSize={true}
        compactType={'horizontal'}
        onLayoutChange={this.onLayoutChange}
        draggableHandle=".productDrag"
        draggableCancel=".MyDragCancel"
        margin={[16, 8]}>
        {this.props.filterList.map((filter, index) => {
          const x = index % this.props.cols
          const y = Math.floor(index / this.props.cols)
          const isActive = this.renderActiveFilter(filter)
          return (
            <div
              className="drag-wrapper"
              key={filter.name}
              data-grid={{
                x: x,
                y: y,
                w: 1,
                h: 1,
                minH: 1,
                maxH: 10,
              }}>
              <div className="productDrag h-100">
                <AccordionBlockFilter
                  isActive={isActive}
                  filter={filter}
                  index={index}
                  renderIcon={this.renderIcon}
                  handleSizeCalc={this.handleSizeCalc}
                  renderFilter={this.props.renderFilter}
                  handleVisibilityToggle={this.handleVisibilityToggle}
                />
              </div>
            </div>
          )
        })}
      </ReactGridLayout>
    )
  }
}

@observer
class AccordionBlockFilter extends React.Component {
  render() {
    const { index, filter, isActive, renderIcon, handleVisibilityToggle } =
      this.props
    return (
      <AccordionBlock
        key={`filter-accordion_${index}`}
        className="filter-facet h-100"
        dataTestId="qa-plp-filter"
        title={filter.name}
        renderIcon={isMerchPLP && renderIcon}
        isActive={isActive}
        isMerchPLP={isMerchPLP}
        onClick={handleVisibilityToggle}
        type={filter.name}
        index={index}>
        <ol
          {...(isMerchPLP && {
            onClickCapture: e => {
              e.stopPropagation()
            },
          })}
          className={`facet-list p-0 m-0 pt-3 h-100 ${isMerchPLP === true ? 'merch-filter-list' : ''
            }`}>
          <fieldset>
            <legend>{filter.name}</legend>
            {this.props.renderFilter(filter)}
          </fieldset>
        </ol>
      </AccordionBlock>
    )
  }
}

export { AccordionDragAndDrop }
export default AccordionDragAndDrop
